import { Component, inject } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InstructionBuilderService } from '../services/instruction-builder.service';
import { AdminControllerComponent } from '../../../../../shared/admin-controller/admin-controller.component';

@Component({
  selector: 'app-instruction-admin',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AdminControllerComponent
],
  templateUrl: './instruction-admin.component.html',
  styleUrl: './instruction-admin.component.scss'
})
export class InstructionAdminComponent {
  instructionForm!: FormGroup;

  #formBuilder = inject(FormBuilder);
  #instructionBuilderService = inject(InstructionBuilderService);

  constructor() {
      this.instructionForm = this.#formBuilder.group({
        isEnabled: new FormControl(this.#instructionBuilderService.instruction().details?.isEnabled ?? true),
        isUniversal: new FormControl(this.#instructionBuilderService.instruction().details?.isUniversal ?? false),
    })
  }

  /**
   * Validates the form and returns whether it's valid or not.
   * Used by the parent component to determine if this step is complete.
   * @returns A boolean indicating whether the form is valid.
   */
  isValid(): boolean {
    if (!this.instructionForm) {
      return false;
    }

    this.instructionForm.markAllAsTouched();
    return this.instructionForm.valid;
  }
}
